// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconfont/iconfont.css
// module id = 503
// module chunks = 1